import { t } from "@i18n";
import {
  SECTION_TYPE_REFERENCE,
  SECTION_TYPE_FORM,
  SECTION_TYPE_TASK,
  SECTION_TYPE_MILESTONE,
  SECTION_TYPE_QUANTITY,
  SECTION_TYPE_TABLE_SECTION,
  SECTION_TYPE_WBS_ITEMS,
  SECTION_TYPE_SUMMARY_OF_CHANGES,
  SECTION_TYPE_REVIEWS,
  SECTION_TYPE_INSPECTION,
  SECTION_TYPE_PROGRESS_UPDATES,
  SECTION_TYPE_BILLS,
  SECTION_TYPE_CHANGE_ORDERS,
  SECTION_TYPE_BLANK_SECTION,
  SECTION_TYPE_PRESET_SECTION,
  SECTION_TYPE_SECTION_FROM_LIBRARY,
  SECTION_TYPE_CUSTOM_MODULES,
  formCategories,
} from "@Helpers";

export const formCategoriesDataSource = [
  { name: t("Inspections"), value: formCategories.inspection },
  { name: t("Progress Updates"), value: formCategories.progressUpdates },
  { name: t("Change Orders"), value: formCategories.changeOrder },
  { name: t("Payments"), value: formCategories.payments },
  { name: t("Mailbox"), value: formCategories.mailBox },
  { name: t("Bills"), value: formCategories.bills },
  { name: t("Issues"), value: formCategories.issues },
  { name: t("Projects"), value: formCategories.projects },
  { name: t("Files"), value: formCategories.files },
  { name: t("Contracts"), value: formCategories.contract },
  { name: t("Model"), value: formCategories.model },
  { name: t("Reviews"), value: formCategories.reviews },
  { name: t("Transmittals"), value: formCategories.transmittal },
  { name: t("Assets"), value: formCategories.assets },
  { name: t("Drawing"), value: formCategories.drawing },
];

export const formCategoryObject = {
  [formCategories.inspection]: {
    formHeader: "Inspection",
    tabTitle: "Inspections",
    activeCell: "Inspections",
    selectedTab: "inspection",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_QUANTITY,
      SECTION_TYPE_WBS_ITEMS,
      // "linkForm",
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_TASK,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
    ],
  },

  [formCategories.progressUpdates]: {
    formHeader: "Progress Update",
    tabTitle: "Progress Updates",
    activeCell: "Progress Updates",
    selectedTab: "progressUpdates",
    allowedSections: [
      // "linkForm",
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_QUANTITY,
      SECTION_TYPE_WBS_ITEMS,
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_TASK,
      SECTION_TYPE_MILESTONE,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
    ],
  },

  [formCategories.mailBox]: {
    formHeader: "Mail Box",
    tabTitle: "Mail Box",
    activeCell: "Mailbox",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
    defaultSection: {
      sectionHeading: "Standard Fields",
      isDefaultSection: true,
      questionFields: [
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "ID",
          editableInForm: true,
          isMetadata: true,
        },
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "Subject",
          editableInForm: true,
          isMetadata: true,
        },
        {
          attachmentsData: [],
          fieldHeading: "User(s)",
          fieldType: "users",
          questionValue: "To",
          selectionScope: "project",
          editableInForm: true,
          selectionType: "multipleUser",
          viewType: "chip",
          isMetadata: true,
        },
        {
          attachmentsData: [],
          fieldHeading: "User(s)",
          fieldType: "users",
          questionValue: "CC",
          selectionScope: "project",
          editableInForm: true,
          selectionType: "multipleUser",
          viewType: "chip",
          isMetadata: true,
        },
        {
          attachmentsData: [],
          fieldHeading: "Date / Time",
          fieldType: "date-time",
          questionValue: "Date",
          editableInForm: true,
          isMetadata: true,
        },
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "Response Type",
          editableInForm: true,
          isMetadata: true,
        },
        {
          attachmentsData: [],
          fieldHeading: "Date / Time",
          fieldType: "date-time",
          questionValue: "Due Date",
          editableInForm: true,
          isMetadata: true,
        },
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "Status",
          editableInForm: true,
          isMetadata: true,
        },
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "Tags",
          editableInForm: true,
          isMetadata: true,
        },
      ],
    },
  },
  [formCategories.bills]: {
    formHeader: "Bill",
    selectedTab: "bills",
    tabTitle: "Bills",
    activeCell: "Bills",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_QUANTITY,
      SECTION_TYPE_WBS_ITEMS,
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_TASK,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
    ],
  },
  [formCategories.changeOrder]: {
    formHeader: "Change Order",
    selectedTab: "changeOrders",
    tabTitle: "Change Order",
    activeCell: "Change Orders",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_REFERENCE,
      SECTION_TYPE_SUMMARY_OF_CHANGES,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_REVIEWS,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_INSPECTION,
      SECTION_TYPE_PROGRESS_UPDATES,
      SECTION_TYPE_BILLS,
      SECTION_TYPE_CHANGE_ORDERS,
    ],
  },
  [formCategories.payments]: {
    formHeader: "Payments",
    selectedTab: "payments",
    tabTitle: "Payments",
    activeCell: "Payments",
    allowedSections: [
      SECTION_TYPE_BLANK_SECTION,
      SECTION_TYPE_TABLE_SECTION,
      SECTION_TYPE_SECTION_FROM_LIBRARY,
      SECTION_TYPE_CUSTOM_MODULES,
      SECTION_TYPE_PRESET_SECTION,
      SECTION_TYPE_REFERENCE,
    ],
  },
  [formCategories.issues]: {
    formHeader: "Issues",
    tabTitle: "Issues",
    activeCell: "Issues",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.projects]: {
    formHeader: "Projects",
    tabTitle: "Projects",
    activeCell: "Projects",
    formType: "projects",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
    singleTemplate: true,
    defaultSection: {
      questionFields: [
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "ID",
        },
        {
          attachmentsData: [],
          fieldHeading: "Single Line",
          fieldType: "single-line",
          questionValue: "Name",
        },
      ],
      sectionHeading: "ProjectDetails",
    },
  },
  [formCategories.files]: {
    formHeader: "Files",
    tabTitle: "Files",
    activeCell: "Files",
    formType: "files",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.contract]: {
    formHeader: "Contract",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.model]: {
    formHeader: "Model",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.reviews]: {
    formHeader: "review",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.transmittal]: {
    formHeader: "transmittals",
    titleLable: "Title",
    descriptionLable: "Description",
    urlKey: "forms",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    listUrlKey: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.assets]: {
    formHeader: "Assets",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    listUrlKey: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
  [formCategories.assets]: {
    formHeader: "Assets (Project Level)",
    selectedTab: "",
    tabTitle: "",
    activeCell: "",
    listUrlKey: "",
    allowedSections: [SECTION_TYPE_BLANK_SECTION, SECTION_TYPE_SECTION_FROM_LIBRARY],
  },
};

export const getPresetSectionsObject = () => ({
  [SECTION_TYPE_QUANTITY]: t("Quantities"),
  [SECTION_TYPE_REFERENCE]: t("References"),
  [SECTION_TYPE_FORM]: t("Forms"),
  [SECTION_TYPE_TASK]: t("Activities"),
  [SECTION_TYPE_MILESTONE]: t("Milestones"),
  [SECTION_TYPE_WBS_ITEMS]: t("WBS Items"),
  [SECTION_TYPE_SUMMARY_OF_CHANGES]: t("Summary of Changes"),
  [SECTION_TYPE_REVIEWS]: t("Reviews"),
  [SECTION_TYPE_INSPECTION]: t("Inspections"),
  [SECTION_TYPE_PROGRESS_UPDATES]: t("Progress Updates"),
  [SECTION_TYPE_BILLS]: t("Bills"),
  [SECTION_TYPE_CHANGE_ORDERS]: t("Change Orders"),
  [SECTION_TYPE_TABLE_SECTION]: t("Table Section"),
});

export const getPresetSectionsDataSource = () => {
  const presetSectionsObject: any = getPresetSectionsObject();
  return [
    { id: SECTION_TYPE_QUANTITY, text: presetSectionsObject[SECTION_TYPE_QUANTITY] },
    { id: SECTION_TYPE_REFERENCE, text: presetSectionsObject[SECTION_TYPE_REFERENCE] },
    // { id: "linkForm", text: presetSectionsObject.SECTION_TYPE_FORM, },
    { id: SECTION_TYPE_TASK, text: presetSectionsObject[SECTION_TYPE_TASK] },
    { id: SECTION_TYPE_MILESTONE, text: presetSectionsObject[SECTION_TYPE_MILESTONE] },
    { id: SECTION_TYPE_WBS_ITEMS, text: presetSectionsObject[SECTION_TYPE_WBS_ITEMS] },
    { id: SECTION_TYPE_SUMMARY_OF_CHANGES, text: presetSectionsObject[SECTION_TYPE_SUMMARY_OF_CHANGES] },
    { id: SECTION_TYPE_INSPECTION, text: presetSectionsObject[SECTION_TYPE_INSPECTION] },
    { id: SECTION_TYPE_PROGRESS_UPDATES, text: presetSectionsObject[SECTION_TYPE_PROGRESS_UPDATES] },
    { id: SECTION_TYPE_BILLS, text: presetSectionsObject[SECTION_TYPE_BILLS] },
    { id: SECTION_TYPE_REVIEWS, text: presetSectionsObject[SECTION_TYPE_REVIEWS] },
    { id: SECTION_TYPE_CHANGE_ORDERS, text: presetSectionsObject[SECTION_TYPE_CHANGE_ORDERS] },
  ];
};

export const presetSections = [
  SECTION_TYPE_REFERENCE,
  SECTION_TYPE_QUANTITY,
  SECTION_TYPE_FORM,
  SECTION_TYPE_TASK,
  SECTION_TYPE_MILESTONE,
  SECTION_TYPE_WBS_ITEMS,
  SECTION_TYPE_SUMMARY_OF_CHANGES,
  SECTION_TYPE_REVIEWS,
  SECTION_TYPE_INSPECTION,
  SECTION_TYPE_PROGRESS_UPDATES,
  SECTION_TYPE_BILLS,
  SECTION_TYPE_CHANGE_ORDERS,
];

export const formTemplateSource = {
  projectSettings: "project_settings",
  portalSettings: "portal_settings",
};

export const moduleIconMapper = {
  [formCategories.inspection]: "inspectionForm",
  [formCategories.progressUpdates]: "ProgressUpdates",
  [formCategories.bills]: "bills",
  [formCategories.payments]: "Payments",
  [formCategories.contract]: "Contracts",
  [formCategories.files]: "files",
  [formCategories.issues]: "issues",
  [formCategories.reviews]: "Review",
  [formCategories.mailBox]: "Mailbox",
  [formCategories.model]: "Models&Drawings",
  [formCategories.changeOrder]: "changeOrder",
  [formCategories.assets]: "Assets",
};
export const sectionTypeMapper: any = {
  [SECTION_TYPE_INSPECTION]: formCategories.inspection,
  [SECTION_TYPE_PROGRESS_UPDATES]: formCategories.progressUpdates,
  [SECTION_TYPE_BILLS]: formCategories.bills,
  [SECTION_TYPE_CHANGE_ORDERS]: formCategories.changeOrder,
};
